import type {EventsMaps} from '../../@types/Events'

class TypedEventDispatcher {
  private readonly target = new EventTarget()

  dispatchEvent(event: EventsMaps[keyof EventsMaps]): void {
    this.target.dispatchEvent(event)
  }

  addEventListener<K extends keyof EventsMaps>(type: K, callback: (event: EventsMaps[K]) => void, options?: AddEventListenerOptions | boolean): void {
    this.target.addEventListener(type, callback as EventListener, options)
  }

  removeEventListener<K extends keyof EventsMaps>(type: K, callback: (event: EventsMaps[K]) => void): void {
    this.target.removeEventListener(type, callback as EventListener)
  }
}

const eventDispatcher = new TypedEventDispatcher()

export default eventDispatcher
